import type * as React from 'react';

function SvgLess(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 20 2" width="1em" {...props}>
      <path d="M20 1a1 1 0 01-1 1H1a1 1 0 010-2h18a1 1 0 011 1z" fill="currentColor" fillRule="evenodd" />
    </svg>
  );
}

export default SvgLess;
